/*
 * @Author: cmchiu
 * @Date: 2022-03-31 17:04:35
 * @LastEditTime: 2022-08-05 11:02:29
 * @LastEditors: cmchiu
 * @Description:
 * @FilePath: \campus2022\campus2022-ClientApp\src\router\index.js
 *
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes.js'

Vue.use(VueRouter)

/**
 * 解决报错问题：报错显示是路由重复
 * Error: Avoided redundant navigation to current location
 */
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

/* const scrollBehavior = function (to, from, savedPosition) {
    if (to.hash) {
        return {
            // 通过 to.hash 的值來找到对应的元素
            selector: to.hash,
        }
    } else if (savedPosition) {
        return savedPosition
    } else {
        return { x: 0, y: 0 }
    }
} */

const createRouter = () =>
    new VueRouter({
        mode: 'history',
        base: process.env.BASE_URL,
        // scrollBehavior: () => ({ y: 0 }),
        // scrollBehavior,
        routes: [...routes],
    })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}

export default router
